import { z } from 'zod';

import { LocaleSchema } from './LocaleSchema';

export const EnabledLocaleSchema = z.object({
	dateFnsLocale: z.string(),
	disabled: z.boolean().optional().default(false),
	label: z.string(),
	locale: LocaleSchema,
	matchingLocales: z.array(z.string()).default([])
});

export type EnabledLocaleSchemaType = z.infer<typeof EnabledLocaleSchema>;
